<template>
  <div>
    <div class="user-form">
      <div class="steps">
        <div class="steps-line-box">
          <div class="steps-line" style="width:100%;"></div>
        </div>
        <ul class="steps-ul">
          <li class="active">{{ $t("lang.steps1") }}</li>
          <li class="active">{{ $t("lang.steps2") }}</li>
          <li class="active">{{ $t("lang.steps3") }}</li>
          <li class="active">{{ $t("lang.steps4") }}</li>
        </ul>
      </div>
      <div class="user-form-img">
        <img src="~assets/images/pic_04@2x.png" alt="">
      </div>
      <div class="form-box">
        <div class="success-title">{{$t("lang.loginPage29")}}<br><br>{{$t("lang.userPage44")}}</div>
        <div class="btn" @click="_updateTeacherStatus" >{{$t("lang.userPage45")}}</div>
      </div>        
    </div>
    <div class="app-bg"></div>
  </div>
</template>
<script>
import { ERR_OK } from "api/config";
import { updateTeacherStatus } from "api/login";
export default {
  data() {
    return {
      param: {
        teacherStatus: 0
      }
    };
  },
  methods: {
    _updateTeacherStatus() {
      updateTeacherStatus(this.param)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.$router.push({
                path: "/index"
              });
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.user-form {
  width: 998px;
  height: 598px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -300px 0px 0px -500px;
  background-color: $white;
  border-radius: 6px;
}
.user-form-img {
  width: 348px;
  height: 225px;
  float: left;
  margin: 67px 76px;
  img {
    display: block;
    width: 100%;
    line-height: 0;
    border: 0;
  }
}
.form-box {
  width: 360px;
  margin: 40px 100px 40px 0px;
  float: right;
  .title-logo {
    display: block;
    width: 155px;
    height: 58px;
    margin: 40px auto 20px;
  }
  .btn {
    width: 285px;
    margin: 0 auto 50px;
  }
}
.success-title {
  margin: 30px 0px 80px;
  font-size: 18px;
  color: $gray;
}
</style>


// WEBPACK FOOTER //
// src/views/me/user-auth-success.vue